var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBuildingBalanceIcon = function SvgBuildingBalanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.751.029c.164-.039.334-.039.498 0a1.401 1.401 0 0 1 .456.217l5.238 3.356a.807.807 0 0 1 .335.896.78.78 0 0 1-.747.578H2.469a.78.78 0 0 1-.747-.578.807.807 0 0 1 .335-.896L7.295.246A1.401 1.401 0 0 1 7.75.029ZM8 1.674 5.181 3.481h5.638L8 1.674ZM3.852 5.607c.43 0 .778.357.778.798v5.67c0 .441-.349.798-.778.798a.788.788 0 0 1-.778-.797V6.405c0-.44.348-.798.778-.798Zm2.765 0c.43 0 .778.357.778.798v5.67c0 .441-.348.798-.778.798a.788.788 0 0 1-.777-.797V6.405c0-.44.348-.798.777-.798Zm2.766 0c.43 0 .778.357.778.798v5.67c0 .441-.349.798-.778.798a.788.788 0 0 1-.778-.797V6.405c0-.44.348-.798.778-.798Zm2.765 0c.43 0 .778.357.778.798v5.67c0 .441-.348.798-.778.798a.788.788 0 0 1-.778-.797V6.405c0-.44.349-.798.778-.798ZM1 14.203c0-.44.348-.798.778-.798h12.444c.43 0 .778.357.778.798 0 .44-.348.797-.778.797H1.778A.788.788 0 0 1 1 14.203Z",
    fill: "currentColor"
  })));
};

export default SvgBuildingBalanceIcon;